export const PageText = {
  _1: 'Developers',
  _2: 'aircheckr can easily be integrated into your own service. Find out more technical info on the use and possibilities of our simple and powerful API and widgets here.'
};

export const Categories = {
  _1: {
    title: "aircheckr token",
    subcategories: [
      {
        key: 0,
        subtitle: 'Your access to aircheckr',
        text: 'All you need to start using aircheckr is a personal aircheckr access token. It is a string of characters that lets you use aircheckr within your own service or product. You automatically get this API key when you sign up to aircheckr. You can find it in your "<a href="/dashboard">personal account page</a>". You can use the same token for all our REST APIs and widgets.'
      }
    ]
  },
  _2: {
    title: 'aircheckr API',
    subcategories: [
      {
        key: 0,
        subtitle: 'Documentation',
        text: 'The aircheckr API documentation gives a more extensive explanation on the API and its use. ',
        linkAddress: '/api_docs',
        linkText: 'To Documentation.',
        linkTarget: "_blank"
      },
      {
        key: 1,
        subtitle: 'Making it peanuts to integrate',
        text: 'Use the API to retrieve the aircheckr content that you need for your service. The aircheckr API allows for a fluid machine-to-machine data transfer (programmatic access) and makes it peanuts to integrate AQ info into your own service.'
      },
      {
        key: 2,
        subtitle: 'It allows to differentiate according to',
        text: 'Location: based on coordinates or an administrative name'
      },
      {
        key: 3,
        text: 'Time: specific moment (e.g. last hour or tomorrow), but also statistics'
      },
      {
        key: 4,
        subtitle: 'What air quality information can I retrieve?',
        text: 'Besides the aircheckr AQI and recommendations, you can get much more information out of aircheckr. Check it out <a href="https://aircheckr.com/help-and-guides/what-air-quality-info-can-i-get">here</a> or see all details in the <a href="/api_docs/" target="_blank">API documentation</a>'
      }
    ]
  },
  _3: {
    title: 'aircheckr widgets',
    subcategories: [
      {
        key: 0,
        subtitle: 'Embed aircheckr in your own website',
        text: 'You can integrate the widget on your website. See here in short how:',
        text_2: 'Step 1:<br/>Include an HTML5 <code>&lt;article&gt;</code> element in your website with class attribute <code>ac-aircheckr-widget</code>, a <code>data-level</code>, a <code>data-type</code> and a <code>data-token</code> attribute like so:<br><code>&lt;article class="ac-aircheckr-widget" data-level="city" data-type="extended" data-token="[your personal aircheckr access token here]"&gt;&lt;/article&gt;</code>',
        text_3: 'Step 2 (optional):<br/>Add additional data attributes to customize your widget: <code>data-theme</code>, <code>data-locale</code>, <code>data-default-location</code>',
        text_4: 'Step 3:<br/>Load the aircheckr widget JavaScript file by placing a script tag after your HTML5 <code>&lt;article&gt;</code> element:<br/><code>&lt;script src="https://widget.aircheckr.com/js/client.widget.js"&gt;&lt;/script&gt;</code><br/><br/><a href="https://www.aircheckr.com/contact">Contact us</a> if you need additional help.'
      },
      {
        key: 1,
        subtitle: 'It allows to differentiate according to'
      },
      {
        key: 2,
        text: 'Language: English or Dutch'
      },
      {
        key: 3,
        text: 'Background: dark (aircheckrgreen) or light (white)'
      }
    ]
  },
  _4: {
    subcategories: [
      {
        key: 1,
        subtitle: 'More info',
        text: 'If you have specific questions, <a href="https://www.aircheckr.com/contact">contact us</a>.'
      }
    ]
  }
};


export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/developers_page.js